//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { BModal } from 'bootstrap-vue'

export default {

    name: 'ProfileModalDetails',

    components: { BModal },

    props: {
        company: {
        }
    },

    data() {
        return {
            modalDetailId: false,
            modalDetailType: false,
            modalData: {},
        }

    },

    mounted() {
        this.$bus.$on('profile/openModalDetail', this.openModal)
    },

    destroyed() {
        this.$bus.$off('profile/openModalDetail', this.openModal)
    },


    methods: {

        openModal(type, id) {

            this.showOverlay()

            this.modalDetailId = id
            this.modalDetailType = type

            this.fetchData()
        },

        fetchData() {

            if(this.modalDetailType === 'case-study') {
                this.fetchCaseStudy()
            } else if (this.modalDetailType === 'product') {
                this.fetchProduct()
            } else if (this.modalDetailType === 'news') {
                this.fetchNews()
            }

        },

        async fetchCaseStudy() {

            try {
                const response = await this.$axios.$get(this.$ziggy.route('api.profile.case-study.data', { caseStudy: this.modalDetailId}))
                this.modalData = response.data
            } catch (e) {
                this.$logger.captureException(e)
            }

            this.showModal()

        },

        async fetchProduct() {

            try {
                const response = await this.$axios.$get(this.$ziggy.route('api.profile.product.data', { product: this.modalDetailId}))
                this.modalData = response.data
            } catch (e) {
                this.$logger.captureException(e)
            }

            this.showModal()

        },

        async fetchNews() {

            try {
                const response = await this.$axios.$get(this.$ziggy.route('api.profile.news.data', { news: this.modalDetailId}))
                this.modalData = response.data
            } catch (e) {
                this.$logger.captureException(e)
            }

            this.showModal()

        },

        showModal: function () {
            this.$refs['modalDetailsProfile'].show()
        },

        hideModal: function () {
            this.$refs['modalDetailsProfile'].hide()
        },

        showOverlay() {
            this.$waiter.throttle('overlay', 300)
        },

        hideOverlay() {
            this.$waiter.end('overlay')
        },

        onHide() {
            this.hideOverlay()
            this.modalDetailId = false,
            this.modalDetailType = false,
            this.modalData = {}
        },

        onShown() {
            //this.hideOverlay()
        },

        onShow() {
            this.hideOverlay()
        }

    },

    computed: {

        modalDetailHeaderClass() {

            if(this.modalDetailType === 'case-study') {
                return 'bg-white'
            }

            return ''
        },

    }
}

